import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: { data: {} },
    table: createTableState(),
    filterData: undefined,
    stockId: null,
})

const getters = {}

const actions = {
    async get({state, commit}, {stockId, page, filterData} = {}) {
        commit('setLoading', true)
        commit('updateTableData', [])

        if (stockId) state.stockId = stockId
        state.filterData = filterData

        const params = {
            page: page?.current,
            page_limit: page?.pageSize,
            ...(filterData || {}),
        }

        try {
            const res = await this._vm.axios.get(this._vm.endpoints['company_stock_movement'], {
                urlVars: { stockId: state.stockId },
                params,
            })
            const { data, meta } = res.data
            commit('updateTableData', data || [])
            if (meta) {
                commit('updatePagination', normalizePagination(meta))
            } else {
                const total = (data || []).length
                commit('updatePagination', { current: 1, pageSize: total || 1, total, sort: [] })
            }
        } finally {
            setTimeout(() => commit('setLoading', false), 250)
        }
    },

    async add({commit, dispatch}, {stockId, formData}) {
        try {
            const res = await this._vm.axios.post(
                this._vm.endpoints['company_stock_movement'],
                formData,
                { urlVars: { stockId } },
            )
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async transfer({commit, dispatch}, {stockId, formData}) {
        try {
            const res = await this._vm.axios.post(
                this._vm.endpoints['company_stock_movement_transfer'],
                formData,
                { urlVars: { stockId } },
            )
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async delete({commit, dispatch}, {stockId, id}) {
        const ids = Array.isArray(id) ? id : [id]
        const successDeleted = []
        if (ids.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
            return successDeleted
        }
        for (const item of ids) {
            try {
                const {data} = await this._vm.axios.delete(
                    this._vm.endpoints['company_stock_movement'] + '/' + item,
                    { urlVars: { stockId } },
                )
                if (data.status) {
                    successDeleted.push(item)
                }
            } catch (error) {
                // interceptor zaten error toastlar
            }
        }
        if (successDeleted.length) {
            this._vm.$message.success(this._vm.$t('messages.deleteOk'))
        }
        return successDeleted
    },

    refresh({dispatch, state}) {
        dispatch('get', { stockId: state.stockId, filterData: state.filterData })
    },
}

const mutations = {
    setLoading(state, val) { state.table.loading = val },
    updateTableData(state, data) { state.table.data = data },
    updatePagination(state, pagination) { state.table.pagination = pagination },
    updateSaveData(state, data) { state.save.data = data },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
